export const NAV_CONTENT = {
  navLinks: [
    {
      name: 'Home',
      path: '/',
    },
    {
      name: 'About Us',
      path: '/about',
    },
    {
      name: 'Parents',
      path: '/parents',
    },
    {
      name: 'FAQs',
      path: '/faq',
    },
  ],
}
